import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResponseMobilePhoneData } from "../../types/common";
import { getMobileData } from "../../methods/Methods";



//-------------------------------------------------------------------------------------------------- Intefaces
export interface FillMobilePhoneSliceInterface {
    clientId: string;
};

export interface MobileTelephonyData extends ResponseMobilePhoneData {
    clientId: string;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const mobilePhoneInitialState: MobileTelephonyData = {
    clientId: "",
    hasCellPhone: false,
    mobilePhones: []
};



//-------------------------------------------------------------------------------------------------- Thunks
const fillMobilePhoneSlice = createAsyncThunk(
    "thunk/mobilePhone",
    async (obj: FillMobilePhoneSliceInterface): Promise<MobileTelephonyData> => {
        let data: MobileTelephonyData = {
            clientId: obj.clientId,
            hasCellPhone: false,
            mobilePhones: []
        };

        await getMobileData(obj.clientId).then((response) => {
            if (response.data && response.data[0]) {
                data.mobilePhones = response.data[0].mobilePhones;
                data.hasCellPhone = response.data[0].hasCellPhone;
            }
        }).catch(() => {});

        return data;
    }
);



//-------------------------------------------------------------------------------------------------- Slice
const mobilePhoneSlice = createSlice({
    name: "mobilePhone",
    initialState: mobilePhoneInitialState,
    reducers: {
        setMobilePhoneData: (state, action: PayloadAction<MobileTelephonyData>) => {
            state.clientId = action.payload.clientId;
            state.hasCellPhone = action.payload.hasCellPhone;
            state.mobilePhones = action.payload.mobilePhones;
        },
        clearMobilePhoneData: (action) => {
            action.clientId = mobilePhoneInitialState.clientId;
            action.hasCellPhone = mobilePhoneInitialState.hasCellPhone;
            action.mobilePhones = mobilePhoneInitialState.mobilePhones;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fillMobilePhoneSlice.fulfilled, (state, action) => {
            state.clientId = action.payload.clientId;
            state.hasCellPhone = action.payload.hasCellPhone;
            state.mobilePhones = action.payload.mobilePhones;
        });
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export {fillMobilePhoneSlice};
export const {
    setMobilePhoneData, clearMobilePhoneData
} = mobilePhoneSlice.actions;
export const getMobilePhoneData = (state: any) => state.mobilePhone as MobileTelephonyData;
export default mobilePhoneSlice.reducer;
